import { useState, useEffect } from 'react'
import { listIncomePaymentTypeAPI } from '../services/income/payment'

function UsePaymentTypeIncome() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await listIncomePaymentTypeAPI()
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d, i) => {
          return { value: d?.paymentListTypeId, label: d?.listTypeName }
        })
        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [])
  return data
}

export default UsePaymentTypeIncome
